import type { FieldConfig } from "./BatchRosterForm"

// Per-type roster field configs (mirror RMS per-type forms + our buildContext
// keys). recipientEditable = the Name cell is a free-text recipient (General).
const POSITIONS = [
  { value: "1", label: "1st" },
  { value: "2", label: "2nd" },
  { value: "3", label: "3rd" },
]

export const TYPE_CONFIG: Record<string, { fields: FieldConfig[]; recipientEditable?: boolean }> = {
  participation: {
    fields: [{ kind: "events", key: "competition_names", label: "Events (per certificate)" }],
  },
  appreciation: {
    fields: [{ kind: "masterSelect", key: "attribution_name", source: "attributions", label: "Attribute" }],
  },
  general: {
    recipientEditable: true,
    fields: [
      { kind: "text", key: "title", label: "Title" },
      { kind: "text", key: "custom_text", label: "Custom text" },
    ],
  },
  sports: {
    fields: [
      { kind: "masterSelect", key: "sport_name", source: "sports", label: "Sport" },
      { kind: "select", key: "position_number", label: "Position", options: POSITIONS },
    ],
  },
  competition: {
    fields: [
      { kind: "masterSelect", key: "competition_name", source: "competitions", label: "Competition" },
      { kind: "select", key: "position_number", label: "Position", options: POSITIONS },
    ],
  },
  winner: {
    fields: [
      { kind: "singleEvent", key: "event", label: "Event" },
      { kind: "select", key: "position_number", label: "Position", options: POSITIONS },
    ],
  },
  graduation: { fields: [{ kind: "text", key: "message", label: "Message" }] },
  outstanding: {
    fields: [
      { kind: "text", key: "message", label: "Message" },
      { kind: "singleEvent", key: "event", label: "Event (optional)" },
      { kind: "select", key: "position_number", label: "Position", options: POSITIONS },
    ],
  },
  cooperative_parents: { fields: [{ kind: "text", key: "message", label: "Message" }] },
  attendance: {
    fields: [
      { kind: "number", key: "days_present", label: "Days Present" },
      { kind: "number", key: "days_total", label: "Days Total" },
    ],
  },
  class_result: {
    fields: [
      { kind: "select", key: "position_number", label: "Position", options: POSITIONS },
      { kind: "text", key: "grade_letter", label: "Grade" },
      { kind: "number", key: "percent", label: "Percent %" },
    ],
  },
}
